
import ObjectCard from '../../components/Card/ObjectCard.vue'
import { getCustomTabsList } from './vehicleGroupTypeCardCustomTabs.js'
import { checkVehicleGroupTypeManagementAccess, checkVehicleGroupTypeApprovalAccess } from './VehicleGroupType.js'

export default {
  name: 'VehicleGroupTypeCard',
  extends: ObjectCard,
  data: function () {
    return {
      typeKeyLocal: 'vehicleGroupType', // @Override
      typeShownLocal: true
    }
  },
  methods: {
    /**
     * ObjectCard
     */
    // @Override
    setObjectType: function (objectTypeKey) {
      // ignore Иначе typeKeyLocal перезапишется
    },
    // @Override
    getRawCustomTabsList: function (config) {
      return getCustomTabsList(config)
    },
    // @Default
    checkUserAccess: function (user, objectAccess) {
      const access = this.getDefaultAccess()

      access.approvalAccess = checkVehicleGroupTypeApprovalAccess(user)
      access.applicantAccess = checkVehicleGroupTypeManagementAccess(user)

      const fullAccess = access.approvalAccess && user.hasRole('admin') && user.fullAccess
      access.editPrivate = fullAccess
      access.viewPrivate = fullAccess
      access.fullAccess = fullAccess

      access.viewPublic = true
      access.editPublic = access.approvalAccess || access.applicantAccess

      access.editAny = access.editPublic
      return access
    }
  }
}
